import { usePageModels } from '@/context/PageModels';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { slugify } from '@/utils/helpers';

export const useHashRef = () => {
  const { config } = usePageModels();
  const ref = React.useRef<HTMLDivElement>(null);
  const location = useLocation();

  React.useLayoutEffect(() => {
    const { hash = '' } = location || {};
    if (!hash || !ref?.current) return;

    const identifier = slugify({ label: hash, rules: config?.translation?.slugify_rules });
    const anchorEl = ref?.current.querySelector(`#${identifier}`);

    if (!anchorEl) return;

    setTimeout(() => anchorEl.scrollIntoView({ behavior: 'smooth' }), 100);
  }, [location, config?.translation?.slugify_rules]);

  return ref;
};
